import type { BadgeProps } from '@/components/ui'

type BadgeVariant = NonNullable<BadgeProps['variant']>

/** Estados nao-terminais em que o aprendizado ainda avanca (poll ativo). */
export function isDiscoveryRunning(status: string): boolean {
  return status === 'Queued' || status === 'Crawling' || status === 'Indexing'
}

/** Estados terminais (poll para). */
export function isDiscoveryTerminal(status: string): boolean {
  return status === 'Ready' || status === 'Failed'
}

/** Ainda nao ha job de aprendizado para o tenant. */
export function isDiscoveryNotStarted(status: string): boolean {
  return status === 'NotStarted'
}

export type DiscoveryStatusLabelKey =
  | 'knowledge.discovery.status.queued'
  | 'knowledge.discovery.status.crawling'
  | 'knowledge.discovery.status.indexing'
  | 'knowledge.discovery.status.ready'
  | 'knowledge.discovery.status.failed'

export function discoveryStatusLabelKey(status: string): DiscoveryStatusLabelKey {
  switch (status) {
    case 'Crawling':
      return 'knowledge.discovery.status.crawling'
    case 'Indexing':
      return 'knowledge.discovery.status.indexing'
    case 'Ready':
      return 'knowledge.discovery.status.ready'
    case 'Failed':
      return 'knowledge.discovery.status.failed'
    default:
      return 'knowledge.discovery.status.queued'
  }
}

export function discoveryStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'Ready':
      return 'success'
    case 'Failed':
      return 'danger'
    case 'Crawling':
    case 'Indexing':
      return 'info'
    default:
      return 'neutral'
  }
}

export type DocumentStatusLabelKey =
  | 'knowledge.documents.status.ready'
  | 'knowledge.documents.status.processing'
  | 'knowledge.documents.status.pending'
  | 'knowledge.documents.status.failed'

export function documentStatusLabelKey(status: string): DocumentStatusLabelKey {
  switch (status) {
    case 'Ready':
      return 'knowledge.documents.status.ready'
    case 'Processing':
      return 'knowledge.documents.status.processing'
    case 'Failed':
      return 'knowledge.documents.status.failed'
    default:
      return 'knowledge.documents.status.pending'
  }
}

export function documentStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'Ready':
      return 'success'
    case 'Failed':
      return 'danger'
    case 'Processing':
      return 'info'
    default:
      return 'neutral'
  }
}

/**
 * Estados terminais do job de importacao de um arquivo enviado (poll para). `Queued`/`Importing`
 * seguem em andamento; qualquer status desconhecido e tratado como terminal para nao repetir o poll
 * indefinidamente contra um valor que o cliente nao entende.
 */
export function isImportTerminal(status: string): boolean {
  return status !== 'Queued' && status !== 'Importing'
}
